<script setup lang="ts">
import {Model} from "@/app/Model";
import PaginazioneReatoRubricaLista from "@/components/atomics/PaginazioneAdminPenaleListaReatoRubrica.vue";
import FiltriReatoRubricaLista from "@/components/atomics/FiltriAdminPenaleListaReatoRubrica.vue";
import ModalAdminReatoRubricaItem from "@/components/atomics/ModalAdminReatoRubricaItem.vue";
import {ref} from "vue";
import {Comms, type IEsito} from "@/app/Comms";
import { Modal } from 'bootstrap';
import {ItemReatoRubrica} from "@/app/data/PenaleAdmin";

let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();

//components
const paginazione_component = ref(null);
const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQueryFiltri(): void {
  callQuery(false);
}
function updateComponents(): void {
  //PAGINAZIONE
  updatePaginazione();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
    }
);
//@ts-ignore
window.updateComponentsAdminReatoRubrica = updateComponents;
//business
function callQuery(soloPaginazione: boolean = false): void {
  Comms.getInstance().penaleAdmin.chiamataReatoRubricaList((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}
function editItem(id: number = 0): void {
  if (id > 0) {
    model.pen_admin.itemReatoRubrica = model.pen_admin.listaReatoRubrica.find( (x)=> x.id == id) as ItemReatoRubrica;
    model.pen_admin.insertModeReatoRubrica = false;
    const modal = Modal.getOrCreateInstance('#ModalAdminReatoRubricaItem');
    modal.show();
  }
}
function deleteItem(id: number = 0): void {
  if (id > 0) {
    model.pen_admin.deleteItemReatoRubrica = model.pen_admin.listaReatoRubrica.find( (x)=> x.id == id) as ItemReatoRubrica;
    if (model.pen_admin.deleteItemReatoRubrica) {
      if (confirm("Sei sicuro di voler cancellare l'elemento " + id) === true) {
        comms.penaleAdmin.chiamataReatoRubricaDel( ()=> {} )
      }
    }
  }
}
function addItem(): void {
  model.pen_admin.itemReatoRubrica = new ItemReatoRubrica();
  model.pen_admin.insertModeReatoRubrica = true;
  const modal = Modal.getOrCreateInstance('#ModalAdminReatoRubricaItem');
  modal.show();
}
</script>

<template>
  <ModalAdminReatoRubricaItem></ModalAdminReatoRubricaItem>
  <FiltriReatoRubricaLista @recalc="callQueryFiltri()"></FiltriReatoRubricaLista>
  <div class="table-responsive small table-documenti" v-if="model.pen_admin.listaReatoRubrica && model.pen_admin.listaReatoRubrica.length && model.pen_admin.listaReatoRubrica.length > 0">
    <table class="table table-striped table-sm table-admin">
      <thead>
      <tr>
        <th>Id</th>
        <th>Capo Imputazione</th>
        <th>Tipo Atto</th>
        <th>Rubrica</th>

        <th scope="col"> </th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in model.pen_admin.listaReatoRubrica">
        <tr :id="'docRiga-reatorubrica-admin-'+index">
          <td>{{ item.id }}</td>
          <td>{{ item.capo_imputazione_str }}</td>
          <td>{{ item.tip_atto }}</td>
          <td>{{ item.rubrica }}</td>
          <td class="text-right"><a href="javascript:void(0)" :title="'Modifica ' + item.id"
                                    @click="editItem(item.id)"><i class="bi bi-pencil-square"></i></a>

            <a href="javascript:void(0)" :title="'Cancella '+ item.id"
               @click="deleteItem(item.id)"><i class="bi bi-trash"></i></a>

          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>


  <div class="row" v-if="model.pen_admin.listaReatoRubrica && model.pen_admin.listaReatoRubrica.length && model.pen_admin.listaReatoRubrica.length > 0">
    <div class="col-12 col-sm-6 paginazione-label">
      <b>{{ model.pen_admin.paginazioneReatoRubrica_tot }}</b> Elementi Totali |
      Pagina <b>{{ (model.pen_admin.paginazioneReatoRubrica_start + 1) }}</b> di
      <b>{{ (model.pen_admin.paginazioneReatoRubrica_pages + 1) }}</b>
    </div>
    <div class="col-12 col-sm-6">
      <PaginazioneReatoRubricaLista ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazioneReatoRubricaLista>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col-12">
      Non sono presenti elementi
    </div>
  </div>

  <div class="row">
    <div class="col-12 azioni-bottoni">
      <a href="javascript:void(0)" title="Aggiungi elemento" class="btn btn-primary"
         @click="addItem()"><i class="bi bi-plus-lg"></i> Aggiungi elemento</a>
    </div>
  </div>
</template>

<style scoped>

</style>